import { Typography } from '@mui/material';
import { InfoAlert } from 'components/alert/InfoAlert';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

function Bold(chunks: React.ReactNode) {
  return <strong>{chunks}</strong>;
}

export function DetailsPagesInfoContent() {
  return (
    <div>
      <InfoAlert messageId="trading.info.alert" values={{ disclaimer: 'Disclaimer:', b: Bold }} />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>

      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="steeringhub.insightsfeed.info.alert_detail.why_is_this_view_useful.description"
      />

      <hr className="my-4 border-snow-200" />

      <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>

      <InfoContentItem
        titleId="trading.gmv.bandchart.title"
        descriptionId="steeringhub.insightsfeed.info.alert_detail.kpi.gmv_trend_vs_expected_range.description"
      />
      <InfoContentItem
        titleId="trading.title.driver.caption.neutral"
        descriptionId="steeringhub.insightsfeed.info.alert_detail.kpi.driver.description"
      />
      <InfoContentItem
        titleId="insights.measure.omsOrdDmvVal.name"
        descriptionId="model.metric.ordGmvVal.description"
      />

      <hr className="my-4 border-snow-200" />

      <InfoContentItem
        titleId="steeringhub.insightsfeed.info.beta.title"
        descriptionId="steeringhub.insightsfeed.info.beta.description"
      />
    </div>
  );
}
